import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
// Data
import MDButton from "../../components/MDButton";
import UserEdit from "./edits/UserEdit";
import buildUserTable from "./data/userTableData";
import apis from "../../context/api";

function Users() {
  const [userUpdate, setUserUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [userData, setUserData] = useState({ columns: [], rows: [] });
  const handleCancel = () => {
    setUserUpdate(false);
  };
  const userUpdated = () => {
    setUserUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editUser = (id) => {
    setId(id);
    setUserUpdate(true);
  };

  const loadTableData = async () => {
    try {
      apis
        .getUsers()
        .then((data) => {
          setUserData(buildUserTable(data, (id) => editUser(id), handleRoleChange));
        })
        .catch((err) => {
          throw new Error("Can not get Users");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  const handleRoleChange = async (userId, roleId) => {
    if (!roleId) return;
    try {
      await apis.assignRoleToUser(userId, roleId);
      loadTableData();
    } catch (err) {
      alert("Failed to update role: " + err.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {userUpdate && <UserEdit onSuccess={userUpdated} id={id} onCancel={handleCancel} />}
      {!userUpdate && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Users
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        setId(null);
                        setUserUpdate(true);
                      }}
                    >
                      Create
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: userData.columns, rows: userData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
